import { appOrigin } from "@/lib/absolute-url";
import { buildFeaturePageLandingPath } from "@garimpa/lib/buildFeaturePageLandingPath";
import { type FeaturePageFamily } from "@garimpa/lib/featurePage";
import { type ViewerLocale } from "@garimpa/lib/viewerPreferences";

export function buildEditorialHubJsonLd(input: {
  description: string;
  families: Array<{
    family: FeaturePageFamily;
    title: string;
    description: string;
  }>;
  locale: ViewerLocale;
  title: string;
  url: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: input.title,
    description: input.description,
    url: input.url,
    inLanguage: input.locale,
    isPartOf: { "@id": `${appOrigin()}/#website` },
    mainEntity: {
      "@type": "ItemList",
      numberOfItems: input.families.length,
      itemListElement: input.families.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.title,
        description: item.description,
        url: `${appOrigin()}${buildFeaturePageLandingPath(input.locale, item.family)}`,
      })),
    },
  };
}
